import { LoomIcon } from '@atlaskit/logo';

import { LogoFromLogo } from '../../logo';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

export const loomConfig: ThirdPartyConfig = {
	displayName: 'Loom',
	id: 'loom',
	icon: LogoFromLogo(LoomIcon, 'small'),
	integrationAri: 'ari:cloud:platform::integration/loom',
	requiresOauth: false,
	isEnabled: () => true,
};
